<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link to="/themes">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to theme </span>
			</router-link>
		</div>
		<base-page-heading
			title="Theme Edit Page"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateThemeEditProperties"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>

		<div class="row content">
			<ThemeEditPageTable
				ref="themeeditpage"
				@routeLayout="routeLayout"
				@routeTemplate="routeTemplate"
				@routePageObject="routePageObject"
			/>
		</div>
	</div>
</template>

<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
